import { FC, useEffect, useRef } from 'react';
import { scrollToItemInBox } from 'shared/lib/scroll';
import { Tooltip } from 'react-tooltip';
import clsx from 'clsx';
import styles from './styles.module.scss';

interface ScheduleFeedItemProps {
	date?: string;
	day?: string | number;
	dayOfWeek?: string;
	isDisable?: boolean;
	isActive?: boolean;
	isLoader?: boolean;
	isCalendarDay?: boolean;
	dayDisable?: boolean;
	selectDay?: (date: string) => void;
}

export const ScheduleFeedItem: FC<ScheduleFeedItemProps> = ({
	date,
	day,
	dayOfWeek,
	isDisable,
	isActive,
	isLoader = false,
	isCalendarDay = false,
	dayDisable = false,
	selectDay,
}) => {
	const buttonRef = useRef<HTMLButtonElement | null>(null);

	const scheduleItemClass = clsx(styles['schedule-feed-list__item'], {
		[styles['schedule-feed-list__item--disable']]: isDisable,
		[styles['schedule-feed-list__item--active']]: isActive === true,
		[styles['schedule-feed-list__item--deactive']]: isActive === false,
		[styles['schedule-feed-list__item--skeleton']]: isLoader,
		[styles['schedule-feed-list__item--calendar-day']]: isCalendarDay,
	});

	const scheduleFeedListDay = clsx(styles['schedule-feed-list__day'], {
		[styles['schedule-feed-list__day--disable']]: dayDisable,
	});

	const handleSelectDay = (date?: string) => () => {
		if (date && !isDisable) {
			selectDay?.(date);
		}
	};

	useEffect(() => {
		if (isActive) {
			const target = buttonRef.current;
			if (target) scrollToItemInBox(target);
		}
	}, [isActive]);

	return (
    <button
      ref={buttonRef}
      className={scheduleItemClass}
      onClick={isLoader ? undefined : handleSelectDay(date)}
      data-tooltip-id={
        isCalendarDay && isDisable ? 'my-tooltip' : 'no-tooltip'
      }
    >
      {isCalendarDay && isDisable && (
        <Tooltip
          id="my-tooltip"
          place="top"
          content="Свободного времени для записи нет"
          className={styles['schedule-feed-list__tooltip']}
        />
      )}
      <div className={scheduleFeedListDay}>{!isLoader && day}</div>
      <div className={styles['schedule-feed-list__day-of-week']}>
        {!isLoader && dayOfWeek}
      </div>
    </button>
	);
};
